import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {
    SearchIcon,
    ThinAddIcon, ThinAddPersonIcon,
    ThinChevronRight, ThinCreditScoreIcon,
    ThinJobIcon, ThinTaskIcon,
    ThinTrashIcon
} from "../../../components/icons/material-icons";
import {Link, useNavigate} from "react-router-dom";
import '../../../static/css/pages/staff/staff.css';
import {AdminsAddEditStaffModal} from "./add-edit-staff";
import {RemoveModal} from "../../../components/template/remove-modal";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface staffInterface {
    id: number,
    name: string,
    img: string,
    isInside: 0 | 1,
    job: string,
}

export const AdminsStaffScreen = () => {
    const [list, setList] = useState<staffInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const navigate = useNavigate();
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: staffInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        navigate('/admins',{replace:true});
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                    }
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchList();
        document.title = 'منابع انسانی | اتوماسیون';
    }, []);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded)
            return;
        const filter = search.toUpperCase().trim();
        const lst = document.querySelector('.staff-list-of-items');
        const btns = (lst as HTMLDivElement).getElementsByClassName('staff-item');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('b')[0];
            if (typeof b === 'undefined')
                continue;
            const v = b.innerHTML.toUpperCase();
            const noSpace = v.replaceAll(' ', '');
            if (v.indexOf(filter) > -1 || noSpace.indexOf(filter.replaceAll(' ', '')) > -1)
                //@ts-ignore
                btns[i].parentElement.style.display = "";
            else //@ts-ignore
                btns[i].parentElement.style.display = "none";
        }
    }, [search]);
    const [addModal, setAddModal] = useState(false);
    const [removeModal, setRemoveModal] = useState({
        show: false,
        id: 0,
        name: '',
    });
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>منابع انسانی</b>
                                <div className="d-flex align-items-center" style={{gap:5}}>
                                    <Link to={"/admins/staff/hire"}>
                                        <ThinAddPersonIcon/>
                                        <span>استخدام</span>
                                    </Link>
                                    <Link to={"/admins/staff/requests"}>
                                        <ThinTaskIcon/>
                                        <span>درخواست‌ها</span>
                                    </Link>
                                    <Link to={"/admins/staff/jobs"}>
                                        <ThinJobIcon/>
                                        <span>مدیریت مشاغل</span>
                                    </Link>
                                    <Link to={"/admins/staff/salaries"}>
                                        <ThinCreditScoreIcon/>
                                        <span>واریز حقوق</span>
                                    </Link>
                                    <button onClick={() => setAddModal(true)}>
                                        <ThinAddIcon/>
                                        <span>کارمند جدید</span>
                                    </button>
                                </div>
                            </div>
                            <div className="pick-device-search">
                                <button><SearchIcon/></button>
                                <input type="text"
                                       value={search}
                                       onChange={e => setSearch(e.currentTarget.value)}
                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                       className="f-roboto"
                                       placeholder={"جستجوی کارمندان..."}
                                />
                            </div>
                            <div className="row staff-list-of-items">
                                {
                                    list.map((s, i) =>
                                        <div className="col-lg-4"
                                             key={"K29sDDD_29DhCj8" + i}>
                                            <div className="staff-item">
                                                <em style={{backgroundImage: `url(${ServerImage(s.img, 200)})`}}/>
                                                <b>{s.name}</b>
                                                <strong data-color={s.isInside === 1 ? 'blue' : 'red'}>
                                                    {s.isInside === 1 ? 'حاضر' : 'عدم حضور'}
                                                </strong>
                                                <div>
                                                    <button className="staff-item-remove"
                                                            onClick={() => setRemoveModal({
                                                                show: true,
                                                                name: s.name,
                                                                id: s.id,
                                                            })}>
                                                        <ThinTrashIcon/>
                                                        <span>حذف</span>
                                                    </button>
                                                    <Link to={`/admins/staff/view/${s.id}`}
                                                          className="staff-item-view">
                                                        <span>مشاهده</span>
                                                        <ThinChevronRight/>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div> :
                    null
            }
            <AdminsAddEditStaffModal
                active={addModal}
                closeHandler={() => setAddModal(false)}
                edit={false}
                staffId={"0"}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف کارمند؟"}
                desc={`آیا مطمئن هستید که می‌خواهید ${removeModal.name} را حذف کنید؟`}
                onRemove={() => {
                    const r = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/staff/remove',
                        {
                            id:r.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'کارمند حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};